import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { http } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/**
 * Gate for client routes: ensures the user has completed onboarding.
 * - If unknown (still loading) → null (calling site usually shows its own loading)
 * - If onboarded → render children
 * - Otherwise → redirect to /app/onboarding
 */
export default function OnboardingGate({ children }) {
  const { user } = useAuth();
  const [status, setStatus] = useState(null); // null = loading, object = loaded

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!user || user.role !== "client") { setStatus({ skip: true }); return; }
      try {
        const { data } = await http.get("/client/onboarding/status");
        if (!cancelled) setStatus(data);
      } catch (e) {
        if (!cancelled) setStatus({ skip: true });
      }
    })();
    return () => { cancelled = true; };
  }, [user]);

  if (status === null) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="id-label text-zinc-500 id-pulse">— Loading —</div>
      </div>
    );
  }
  if (status.skip) return children;
  if (!status.onboarded_at) return <Navigate to="/app/onboarding" replace />;
  return children;
}
